import { $, addAction, INIT } from '@situation/setdesign.util';
import { sceneController } from '../../shared/animations/setup';

/* global ScrollMagic */
addAction(INIT, () => {
    const $count = $('.count');

    function animatedNumbers() {
        const $numbers = $(this.triggerElement()).find('.count__numbers');
        const parseIntoNumber = parseFloat($numbers.html().replace(/[^\d.]/g, ''));
        const decimalPlaces = parseIntoNumber !== Math.floor(parseIntoNumber) ? 1 : 0;
        $numbers.html(parseIntoNumber);
        $numbers.prop('Counter', 0).animate(
            { Counter: $numbers.text() },
            {
                duration: 2000,
                easing: 'swing',
                step(now) {
                    $numbers.text(now.toLocaleString(undefined, { maximumFractionDigits: decimalPlaces }));
                },
            },
        );
    }

    $count.each((index, element) => {
        const options = { triggerElement: element, triggerHook: 0.75 };
        const scene = new ScrollMagic.Scene(options)
            .setClassToggle(element, 'count--active')
            .reverse(false)
            .on('start', animatedNumbers);
        scene.addTo(sceneController);
    });
});
